var map = {
	"./poi-airports.png": 1586,
	"./poi-amusementparks.png": 1587,
	"./poi-atms.png": 1588,
	"./poi-autoservices.png": 1589,
	"./poi-banks.png": 1590,
	"./poi-busstations.png": 1591,
	"./poi-campgrounds.png": 1592,
	"./poi-casinos.png": 1593,
	"./poi-citytownhalls.png": 1594,
	"./poi-communitycenters.png": 1595,
	"./poi-conventioncenters.png": 1596,
	"./poi-ferryterminals.png": 1597,
	"./poi-galleries.png": 1598,
	"./poi-gasstations.png": 1599,
	"./poi-golfcourses.png": 1600,
	"./poi-grocerystores.png": 1601,
	"./poi-hospitals.png": 1602,
	"./poi-hotels.png": 1603,
	"./poi-landmarks.png": 1604,
	"./poi-libraries.png": 1605,
	"./poi-marinas.png": 1606,
	"./poi-movietheaters.png": 1607,
	"./poi-museums.png": 1608,
	"./poi-nationalparks.png": 1609,
	"./poi-nightclubs.png": 1610,
	"./poi-parking.png": 1611,
	"./poi-parks.png": 1612,
	"./poi-pharmacies.png": 1613,
	"./poi-policestations.png": 1614,
	"./poi-postoffices.png": 1615,
	"./poi-rentalcaragencies.png": 1616,
	"./poi-restareas.png": 1617,
	"./poi-restaurants.png": 1618,
	"./poi-restaurantschinese.png": 1619,
	"./poi-restaurantsindian.png": 1620,
	"./poi-restaurantsjapanese.png": 1621,
	"./poi-restaurantspizza.png": 1622,
	"./poi-restaurantssteak.png": 1623,
	"./poi-restaurantsthai.png": 1624,
	"./poi-schools.png": 1625,
	"./poi-shopping.png": 1626,
	"./poi-skiresorts.png": 1627,
	"./poi-stadiumsandarenas.png": 1628,
	"./poi-subwaystations.png": 1629,
	"./poi-theaters.png": 1630,
	"./poi-trainstations.png": 1631,
	"./poi-wineries.png": 1632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1116;